(ns dashboard.components.copy
  (:require [clojure.string :as str]
            [re-frame.core :as rf]
            [dashboard.notifications :as notifications]
            [dashboard.html :as html]))

(defn CopyToClipboard [field-name field]
  (when-not (str/blank? field)
    [:button.button.is-small.is-secondary.is-rounded.ml-2
     {:title "Click to copy to clipboard"
      :on-click (fn [_]
                  (js/navigator.clipboard.writeText (html/strip-markup field))
                  (rf/dispatch [::notifications/add {:message (str field-name " copied to clipboard")}]))}
     [:span.icon>i.fas.fa-copy]]))
